export default __webpack_public_path__ + "static/media/chevron-left@1x.cd87e89d.svg";